module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.model), function(child) {
    return (child.subOrganizations.length) ? _c('el-submenu', {
      class: {
        'el-menu-active': _vm.isActive(child)
      },
      attrs: {
        "index": child.uuid
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _c('dq-sidemenu', {
      staticClass: "item",
      attrs: {
        "model": child.subOrganizations
      }
    })], 2) : _c('el-menu-item', {
      class: {
        'el-menu-active': _vm.isActive(child)
      },
      attrs: {
        "index": child.uuid
      },
      on: {
        "click": function($event) {
          _vm.goToRoute(child.uuid)
        }
      }
    }, [_vm._v(_vm._s(child.name))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3be91a86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/sidemenu/src/sidemenu.vue
// module id = 499
// module chunks = 36